module.exports = {
  x_of_y_questions_learned: '%{x} von %{y} Fragen gelernt',
  n_questions: '1 Frage | %{n} Fragen',
  n_questions_in_box: '1 Frage in dieser Box | %{n} Fragen in dieser Box',
  n_questions_learned: '1 gelernte Frage | %{n} gelernte Fragen',
  n_questions_remaining: '1 Frage übrig | %{n} Fragen übrig',
  n_questions_remaining_in_box: 'noch 1 Frage in dieser Box | noch %{n} Fragen in dieser Box',
  box_1_title: '1-mal-richtig-Box',
  box_2_title: '2-mal-richtig-Box',
  learning: {
    all_questions_done: 'Du hast alle Fragen in dieser Box bearbeitet.',
    congratulations: 'Glückwunsch!',
  },
  how_does_it_work: 'Wie funktioniert das Powerlearning?',
  how_does_it_work_short: 'Wie funktioniert Powerlearning?',
  box_0_title: 'Frische Fragen Box',
  box_3_title: '3-mal-richtig-Box (gelernt)',
  explanation3: "Wird eine Frage falsch beantwortet, wird die Frage wieder in die 'Frische Fragen Box' einsortiert",
  explanation1: 'Im Trainingsmodus muss eine Frage drei mal richtig beantwortet werden, um als "gelernt" zu gelten.',
  currently_no_questions: 'Für diese Kategorie befinden sich im Moment keine Fragen in der Box. Beantworte die Fragen in den darunter liegenden Boxen um Fragen auf das nächste Level zu bringen:',
  to_box_overview: 'Zur Box-Übersicht',
  go_to_powerlearning: 'Zum Powerlearning',
  close: 'Powerlearning beenden',
  intro_text: 'Powerlearning verstärkt dein Wissen durch mehrfache Wiederholung der Lerninhalte.',
  choose_box: 'Box wählen',
  explanation2: 'Das System stellt nur Fragen, die noch nicht als gelernt markiert sind. Es gelten keine zeitlichen Limits oder Beschränkungen.',
  question_learned: 'Super. Frage gelernt!',
}
